import { IonChip, IonIcon, IonLabel } from '@ionic/react'
import { bulb } from 'ionicons/icons'
import { Button } from '~/shared/ui/Buttons'
import { Modal } from '~/shared/ui/Modal'
import { ButtonsWrapper } from './styled'

type WarningModalProps = {
  isShow: boolean
  onCancel: () => void
  onOk: () => void
  isSubmitting: boolean
}

export function WarningModal({
  isShow,
  onCancel,
  onOk,
  isSubmitting,
}: WarningModalProps) {
  return (
    <Modal isShow={isShow}>
      <IonChip color='primary' style={{ alignItems: 'flex-start' }}>
        <IonIcon
          icon={bulb}
          style={{ width: '60px', marginTop: '6px' }}
        ></IonIcon>
        <IonLabel>
          <strong>Обратите внимание:</strong> Услуга будет подключена/отключена
          в течение 15 минут после заявки. Оплата списывается при подключении и
          далее — ежедневно в 01:00 (по МСК), пока услуга активна.
          <br />
          При отключении новые списания остановятся, но деньги за уже оплаченный
          день не возвращаются.
        </IonLabel>
      </IonChip>

      <ButtonsWrapper>
        <Button
          fullWidth
          variant='lightSteelBlueBorder'
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Отмена
        </Button>
        <Button
          onClick={onOk}
          loading={isSubmitting}
          variant='limeFlooded'
          fullWidth
        >
          Применить
        </Button>
      </ButtonsWrapper>
    </Modal>
  )
}
